"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProvider = exports.PartLibrarySearchFilters = exports.SiteSearchFilters = exports.TypesenseSearchOrganizationData = exports.AlgoliaSearchOrganizationData = exports.SearchOrganizationData = exports.TypesenseSearchUserEmailData = exports.AlgoliaSearchUserData = exports.TypesenseSearchUserData = exports.SearchUserData = exports.TypesenseSearchDocumentData = exports.AlgoliaSearchDocumentData = exports.QdrantSearchPartData = exports.TypesenseSearchPartData = exports.AlgoliaSearchPartData = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const handle_1 = require("./handle");
const identifier_1 = require("./identifier");
const permission_1 = require("./permission");
const workspace_1 = require("./workspace");
const SearchPartData = zod_1.default.object({
    // IAlgoliaAccessPermissionMixin
    userAccessList: zod_1.default.array(zod_1.default.string()),
    anyoneCanView: zod_1.default.boolean(),
    // IStarCountMixin
    star_count: zod_1.default.number().readonly(),
    // ITestDataMixin
    test_data: zod_1.default.boolean(),
    // IOrganizationOwnerMixin
    owner_uid: identifier_1.UserUid,
    organization_owner_uid: identifier_1.OrganizationUid.optional(),
    organization_member_permission_type: zod_1.default.nativeEnum(permission_1.PermissionType).optional(),
    // IEnterpriseOwnerMixin
    enterprise_owner_uid: identifier_1.EnterpriseUid.optional(),
    enterprise_member_permission_type: zod_1.default.nativeEnum(permission_1.PermissionType).optional(),
    enterprise_owner_handle: handle_1.EnterpriseHandle.optional(),
    organization_owner_is_enterprise_default: zod_1.default.boolean().optional(),
    uid: zod_1.default.string(),
    /** {@inheritdoc IDocumentData.name} */
    name: zod_1.default.string(),
    /** {@inheritdoc IDocumentData.has_custom_name} */
    has_custom_name: zod_1.default.boolean().optional(),
    // for matching substrings in the name
    nameSuffixes: zod_1.default.array(zod_1.default.string()).optional(),
    description: zod_1.default.string(),
    preview_image: zod_1.default.string().optional(),
    // QUESTION: Should both TS be required??
    // when the part was originally published
    created_at: zod_1.default.number().optional(),
    // When the latest partVersion was published
    updated_at: zod_1.default.number().optional(),
    defaultValueSynonyms: zod_1.default.array(zod_1.default.string()).optional(),
    properties: zod_1.default.array(zod_1.default.custom()).optional(),
    part_type: zod_1.default.string().optional(),
    part_sub_type: zod_1.default.string().optional(),
    part_type_specific_values: zod_1.default.custom(),
    mount: zod_1.default.string().optional(),
    package_case_code: zod_1.default.string().optional(),
    manufacturer: zod_1.default.string().optional(),
    terminal_count: zod_1.default.number().optional(),
    compliance: zod_1.default.array(zod_1.default.string()).optional(),
    archived: zod_1.default.boolean().optional(),
    version: zod_1.default.string().optional(),
    use_count: zod_1.default.number().optional(),
    has_behaviour: zod_1.default.boolean().optional(),
    has_datasheet: zod_1.default.boolean().optional(),
    has_mpn: zod_1.default.boolean().optional(),
    has_sim_model: zod_1.default.boolean().optional(),
    layout_count: zod_1.default.number().optional(),
    sub_layout_count: zod_1.default.number().optional(),
    footprint_count: zod_1.default.number().optional(),
    three_d_model_count: zod_1.default.number().optional(),
    owner_name: zod_1.default.string().optional(),
    owner_handle: zod_1.default.string().optional(),
    // TODO: Turn to zod schema
    partVersionData: zod_1.default.custom().optional(),
    contentScore: zod_1.default.number().default(0),
    lowest_price: zod_1.default.number().optional(),
    available_at_distributors: zod_1.default.array(zod_1.default.string()).optional(),
});
exports.AlgoliaSearchPartData = zod_1.default.object({
    ...SearchPartData.shape,
    objectID: zod_1.default.string(),
});
exports.TypesenseSearchPartData = zod_1.default.object({
    ...SearchPartData.shape,
    id: zod_1.default.string(),
});
exports.QdrantSearchPartData = zod_1.default.object({
    ...SearchPartData.shape,
    id: zod_1.default.string(),
    vector_embeddings: zod_1.default.array(zod_1.default.number()).optional(),
});
// Search data for document
const SearchDocumentData = zod_1.default.object({
    // IBaseMixin
    uid: zod_1.default.string().readonly(),
    // IOrganizationOwnerMixin
    owner_uid: identifier_1.UserUid,
    organization_owner_uid: identifier_1.OrganizationUid.optional(),
    organization_member_permission_type: zod_1.default.nativeEnum(permission_1.PermissionType).optional(),
    // IEnterpriseOwnerMixin
    enterprise_owner_uid: identifier_1.EnterpriseUid.optional(),
    enterprise_member_permission_type: zod_1.default.nativeEnum(permission_1.PermissionType).optional(),
    enterprise_owner_handle: handle_1.EnterpriseHandle.optional(),
    organization_owner_is_enterprise_default: zod_1.default.boolean().optional(),
    // ITimestampMixin
    created_at: zod_1.default.number().readonly(),
    updated_at: zod_1.default.number().readonly(),
    // IThumbnailMixin
    preview_image: zod_1.default.string().optional(),
    // IAlgoliaAccessPermissionMixin
    userAccessList: zod_1.default.array(zod_1.default.string()),
    anyoneCanView: zod_1.default.boolean(),
    // IForkCountMixin
    fork_count: zod_1.default.number().readonly(),
    // IStarCountMixin
    star_count: zod_1.default.number().readonly(),
    // ICommentCountMixin
    comment_count: zod_1.default.number().readonly(),
    // IUsageCountMixin
    usage_count: zod_1.default.number().readonly(),
    // ICopyCountMixin
    copy_count: zod_1.default.number().readonly(),
    // IPublishedMixin
    belongs_to_part_uid: zod_1.default.string(),
    // ITestDataMixin
    test_data: zod_1.default.boolean(),
    // Fields picked from IDocumentData
    contributor_uids: zod_1.default.array(zod_1.default.string()).optional(),
    name: zod_1.default.string(),
    has_custom_name: zod_1.default.boolean().optional(),
    slug: zod_1.default.string(),
    description: zod_1.default.string(),
    owner_handle: handle_1.UserHandle.or(handle_1.OrganizationHandle),
    archived: zod_1.default.boolean(),
    // searchable document data
    // Additional fields we create when converting a document data from firebase to search data
    is_published: zod_1.default.boolean(),
    is_organization_owned: zod_1.default.boolean(),
    partUid: zod_1.default.string(),
});
// Searchable documents we put in Algolia, `objectID` is the unique record identifier
// used by Algolia
exports.AlgoliaSearchDocumentData = zod_1.default.object({
    ...SearchDocumentData.shape,
    objectID: zod_1.default.string(),
});
// Searchable documents we put in Typesense, `id` is the unique record identifier
// used by Typesense
exports.TypesenseSearchDocumentData = zod_1.default.object({
    ...SearchDocumentData.shape,
    id: zod_1.default.string(),
});
exports.SearchUserData = zod_1.default.object({
    uid: zod_1.default.string(),
    star_count: zod_1.default.number().readonly(),
    documents_count: zod_1.default.number().readonly(),
    parts_count: zod_1.default.number().readonly(),
    follower_count: zod_1.default.number().readonly(),
    following_count: zod_1.default.number().readonly(),
    twitter_handle: zod_1.default.string().optional(),
    github_handle: zod_1.default.string().optional(),
    website_url: zod_1.default.string().optional(),
    picture: zod_1.default.string().optional(),
    custom_picture_key: zod_1.default.string().optional(),
    // ITimestampMixin
    created_at: zod_1.default.number().readonly(),
    updated_at: zod_1.default.number().readonly(),
    test_data: zod_1.default.boolean(),
    full_name: zod_1.default.string().optional(),
    handle: zod_1.default.string().readonly(),
    tag_line: zod_1.default.string().optional(),
    last_active_at: zod_1.default.number(),
    archived: zod_1.default.boolean(),
    organization_member_uids: zod_1.default.array(zod_1.default.string()),
    organization_owner_uids: zod_1.default.array(zod_1.default.string()),
    seo: zod_1.default.string().optional(),
    sla: zod_1.default.string().optional(),
    verified: zod_1.default.boolean().optional(),
    // IAlgoliaAccessPermissionMixin
    userAccessList: zod_1.default.array(zod_1.default.string()),
    anyoneCanView: zod_1.default.boolean(),
});
exports.TypesenseSearchUserData = zod_1.default.object({
    ...exports.SearchUserData.shape,
    id: zod_1.default.string(),
});
exports.AlgoliaSearchUserData = zod_1.default.object({
    ...exports.SearchUserData.shape,
    objectID: zod_1.default.string(),
});
exports.TypesenseSearchUserEmailData = zod_1.default.object({
    id: zod_1.default.string(),
    handle: zod_1.default.string().readonly(),
    email: zod_1.default.string().readonly(),
    emailDomain: zod_1.default.string().readonly(),
    // We don't need is_test or isAnonymous here, because they are always filtered out of this index completely
    // IAlgoliaAccessPermissionMixin - but configured with no access at all, so only admin clients (i.e. backend) can query this
    userAccessList: zod_1.default.array(zod_1.default.string()).length(0),
    anyoneCanView: zod_1.default.literal(false),
});
exports.SearchOrganizationData = zod_1.default.object({
    ...workspace_1.Organization.shape,
    // IAlgoliaAccessPermissionMixin
    userAccessList: zod_1.default.array(zod_1.default.string()),
    anyoneCanView: zod_1.default.boolean(),
    // ITestDataMixin
    test_data: zod_1.default.boolean(),
    archived: zod_1.default.boolean(),
});
exports.AlgoliaSearchOrganizationData = zod_1.default.object({
    ...exports.SearchOrganizationData.shape,
    objectID: zod_1.default.string(),
});
exports.TypesenseSearchOrganizationData = zod_1.default.object({
    ...exports.SearchOrganizationData.shape,
    id: zod_1.default.string(),
    seo: zod_1.default.literal("banned").or(zod_1.default.literal("not_banned")).optional(),
    // Overwriting them to optional just so we can backfill real (but old) orgs to Typesense
    partsCount: zod_1.default.number().int().nonnegative().finite().optional(),
    documentsCount: zod_1.default.number().int().nonnegative().finite().optional(),
    follower_count: zod_1.default.number().int().nonnegative().finite().optional(),
    following_count: zod_1.default.number().int().nonnegative().finite().optional(),
    // Normalized field names for union search compatibility with users collection
    created_at: zod_1.default.number().int().optional(),
    updated_at: zod_1.default.number().int().optional(),
    last_active_at: zod_1.default.number().int().optional(),
});
exports.SiteSearchFilters = {
    isTestData: (isTestData) => `test_data:${isTestData}`,
    isSeoBanned: (isSeoBanned) => `seo:${isSeoBanned ? "banned" : "not_banned"}`,
};
exports.PartLibrarySearchFilters = {
    ...exports.SiteSearchFilters,
    isArchived: (isArchived) => `archived:${isArchived}`,
    isPublic: (isPublic) => `anyoneCanView:${isPublic}`,
    userHasAccess: (userUid, searchProvider = "algolia") => searchProvider === "typesense" ? `userAccessList:=[${userUid}]` : `userAccessList:${userUid}`,
    anyUsersHaveAccess: (uids, searchProvider = "algolia") => searchProvider === "typesense"
        ? `userAccessList:=[${uids.join(",")}]`
        : uids.map((uid) => exports.PartLibrarySearchFilters.userHasAccess(uid)).join(" OR "),
    organizationOwnerUid: (organizationUid) => `organization_owner_uid:${organizationUid}`,
};
exports.SearchProvider = zod_1.default.literal("algolia").or(zod_1.default.literal("typesense")).or(zod_1.default.literal("qdrant"));
//# sourceMappingURL=search.js.map